<template>
  <div>
    <content-placeholder v-if="loading">
      <el-card>
        <p class="text text-10 text-h-20"></p>
        <p class="text text-50"></p>
        <p class="text text-25"></p>
        <p class="text text-25"></p>
      </el-card>
    </content-placeholder>

    <el-card v-else>
      <div slot="header">
        <i class="global-icon far fa-folders"></i>
        <span>Revisions ({{versions.length}})</span>
      </div>
      <div v-if="loadError">
        <error-block :buttonCallback="fetchVersionsForObject" />
      </div>
      <div v-else>
        <div v-if="versions && versions.length > 0">
          <el-table
            :data="versions"
            style="width: 100%">
            <el-table-column
              label="Author">
              <template slot-scope="scope">
                <strong class="author">
                  <span v-if="currentUser.id === scope.row.user_id">
                    You
                  </span>
                  <span v-else>
                    {{ scope.row.user.email }}
                  </span>
                </strong>
              </template>
            </el-table-column>
            <el-table-column
              label="Created">
              <template slot-scope="scope">
                {{ scope.row.model.updated_at | formatTime }} 
              </template>
            </el-table-column>
            <el-table-column
              label=""
              width="80">
              <template slot-scope="scope">
                <el-tooltip effect="dark" content="View Revision" placement="bottom">
                  <el-button size="mini" type="primary" @click="handleOpenDiffModal(scope.row.id)"><i class="fas fa-search"></i></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="not-found">
          No versions found.
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'VersionsList',
    props: {
      id: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
    },
    components: {
    },
    created() {
      this.fetchVersionsForObject();
    },
    data() {
      return {
        loading: true,
        loadError: null,
      };
    },
    computed: {
      ...mapGetters('entities/users', ['currentUser']),
      ...mapGetters('entities/versions', ['query']),

      versions() {
        return this.query()
          .with('user')
          .orderBy('created_at', 'desc')
          .where('item_id', this.id)
          .where('item_type', this.type)
          .get();
      },
    },
    methods: {
      ...mapActions('entities/versions', ['fetchVersions', 'setContext', 'openDiffModal']),

      handleOpenDiffModal(id) {
        this.setContext(id);
        this.openDiffModal();
      },

      fetchVersionsForObject() {
        this.loading = true;
        this.loadError = null;
        this.fetchVersions({ id: this.id, type: this.type })
          .then((response) => {
            if (!response.status) {
              this.loadError = response.error;
            }

            this.loading = false;
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/version/VersionsList.vue